export const PLANS_START = 'PLANS_START';
export const PLANS_VE_START = 'PLANS_VE_START';
export const PLANS_SUCCESS = 'PLANS_SUCCESS';
export const PLANS_FAIL = 'PLANS_FAIL';
export const PLANS_FINISH = 'PLANS_FINISH';
export const PLAN_DEFAULT_SELECTED = 'PLAN_DEFAULT_SELECTED';
export const PLAN_SELECTED = "PLAN_SELECTED";
export const SPECIAL_COVERAGE = "SPECIAL_COVERAGE";
export const PLAN_SAVING_SELECTED = "PLAN_SAVING_SELECTED";
export const TYPE_OF_FINANCING = "TYPE_OF_FINANCING";
export const NAME_PLAN_SELECTED = "NAME_PLAN_SELECTED";
export const COVERAGE_PLAN = "COVERAGE_PLAN";
export const SET_NAME_FREQUENCY = "SET_NAME_FREQUENCY";
export const ADD_THIRD_INIT = 'ADD_THIRD_INIT';
export const ADD_THIRD_SUCCESS = 'ADD_THIRD_SUCCESS';
export const SAVE_PLAN_ID = "SAVE_PLAN_ID";
export const SET_CURRENCY_PLAN = "SET_CURRENCY_PLAN";
export const SET_MAX_AMOUNT_QUOTE = "SET_MAX_AMOUNT_QUOTE"; 
export const SET_FINANCIAL_ENTITIES = "SET_FINANCIAL_ENTITIES";
export const SET_SUM_ASSURED = "SET_SUM_ASSURED";
export const SET_PREFETCHED_SUM_ASSURED = "SET_PREFETCHED_SUM_ASSURED";
